exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6a2db496]:export {\n  primary: #aa4121;\n  secondary: #ccc;\n  gray: #636363;\n}\n.torah-resources-page a[data-v-6a2db496]:hover {\n  text-decoration: none;\n}\n.torah-resources-page .resources-container img[data-v-6a2db496] {\n  height: 100%;\n  width: 100%;\n}", ""]);

// exports
